module.exports = __webpack_public_path__ + "img/pc_2.411b47e2.jpg";